/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState: any = {
  textSize: 'small',
};

export const TableTextSizeSlice = createSlice({
  name: 'table-text-size',
  initialState,
  reducers: {
    /**
     * Function to change textSize
     * @param {any} state - The current state.
     * @param {any} action - The action
     */
    setTextSize: (state, action) => {
      console.log(action.payload, 'dffg');
      state.textSize = action.payload;
    },
  },
});

// Export the reducer
export const { setTextSize } = TableTextSizeSlice.actions;

export default TableTextSizeSlice.reducer;
